import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/user-placeholder.jpg'


const _withScopeId = n => (_pushScopeId("data-v-4f6b261a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-justify-between tw-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "tw-relative tw-h-[40px]"
}
const _hoisted_3 = {
  key: 0,
  class: "tw-rounded-full tw-border-solid tw-border-white tw-w-full tw-h-full tw-object-cover",
  src: _imports_0
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "tw-relative tw-h-[40px]"
}
const _hoisted_6 = { class: "tw-ml-5" }
const _hoisted_7 = { class: "tw-flex tw-items-center tw-gap-[16px]" }
const _hoisted_8 = { class: "tw-flex tw-items-center tw-gap-1 tw-mt-4" }
const _hoisted_9 = { class: "tw-text-[20px] tw-font-[700] tw-leading-[25.1px] tw-text-[#0c0f4a]" }
const _hoisted_10 = {
  key: 0,
  class: "tw-text-[10px] tw-font-[600] tw-leading-[22px]"
}
const _hoisted_11 = { class: "tw-flex tw-items-center tw-gap-1 tw-mt-1 tw-pb-2 tw-border-0 tw-border-b tw-border-solid tw-border-[#F1F6FB]" }
const _hoisted_12 = { class: "tw-flex tw-items-center tw-font-[600] tw-text-[10px] tw-text-[#0C0F4A8a]" }
const _hoisted_13 = {
  key: 0,
  class: "tw-flex tw-items-center tw-font-[600] tw-text-[10px] tw-text-[#0C0F4A8a]"
}
const _hoisted_14 = { class: "tw-flex tw-items-center tw-gap" }
const _hoisted_15 = { class: "tw-font-[400] tw-text-[12px] tw-text-[#0C0F4A]" }
const _hoisted_16 = { class: "tw-text-left tw-flex tw-items-center tw-mt-3" }
const _hoisted_17 = {
  key: 0,
  class: "tw-flex tw-items-center tw-px-2 tw-py-1 tw-bg-[#F1F6FB]"
}
const _hoisted_18 = { class: "tw-pl-[4px] tw-text-[12px] tw-font-bold tw-text-[#1FB27A] tw-tracking-[0.15px] tw-mr-1" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[12px] tw-font-bold tw-font-[#0C0F4A] tw-tracking-[0.15px]" }, " Exp. ", -1))
const _hoisted_20 = {
  key: 1,
  class: "tw-flex tw-gap-2"
}
const _hoisted_21 = { class: "category__icon tw-w-[16px] tw-h-[16px] tw-rounded-full tw-bg-[#0c0f4a] tw-flex tw-items-center tw-justify-center" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "tw-font-bold tw-text-[#0C0F4A] tw-text-sm tw-truncate tw-max-w-[140px] tw-inline-block lg:tw-max-w-[100px]" }
const _hoisted_24 = {
  key: 2,
  class: "tw-bg-[#0C0F4A] tw-rounded-full tw-text-white tw-text-[10px] tw-font-bold tw-w-[20px] tw-h-[20px] tw-leading-normal tw-flex tw-items-center tw-justify-center ml-2"
}
const _hoisted_25 = { class: "tw-mt-4" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full tw-h-[1px] tw-bg-gray-200 tw-mb-1" }, null, -1))
const _hoisted_27 = { class: "tw-grid tw-grid-cols-3" }
const _hoisted_28 = { class: "tw-flex tw-flex-col tw-gap-2 tw-items-center tw-justify-center" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-font-[500] tw-text-[12px] tw-text-[#00000080]" }, " Start Date ", -1))
const _hoisted_30 = { class: "tw-font-[700] tw-text-[14px] tw-text-[#0C0F4A]" }
const _hoisted_31 = { class: "tw-flex tw-flex-col tw-gap-2 tw-items-center tw-justify-center" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-font-[500] tw-text-[12px] tw-text-[#00000080]" }, " Duration ", -1))
const _hoisted_33 = { class: "tw-font-[700] tw-text-[14px] tw-text-[#0C0F4A]" }
const _hoisted_34 = { class: "tw-flex tw-flex-col tw-gap-2 tw-items-center tw-justify-center" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-font-[500] tw-text-[12px] tw-text-[#00000080]" }, " Cost ", -1))
const _hoisted_36 = { class: "tw-font-[700] tw-text-[14px] tw-text-[#0C0F4A]" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-w-full tw-h-[1px] tw-bg-gray-200 tw-mt-1" }, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-mt-4" }, null, -1))

import Button from "@/core/uni-components/Button.vue";
import ImageHolder from "@/core/uni-components/ImageHolder.vue";
import Text from "@/core/uni-components/Text.vue";
import EstimateBadge from "@/core/uni-components/EstimateBadge.vue";
import IconButton from "@/core/uni-components/IconButton.vue";
import CustomBadge from "@/core/uni-components/CustomBadge.vue";
import { computed } from "vue";
import moment from "moment";
import { EstimateTypeForDeposit } from "../enums/estimateEnum";
import { ref, onBeforeMount, onMounted } from "vue";
import {
  getImageApiUrl,
  getImageStringToImageURL,
  getUserSubSkillList,
  parseJSON,
} from "../utils/common";
import $axios from "@/core/utils/axios-api-config";
import ProfileThumbnail from "@/core/uni-components/ProfileThumbnail.vue";
import CurrencyFilter from "@/filters/currency.filter";
import { USER_STORE } from "@/store/modules/user";
import { useStore } from "vuex";
import { WORKSTATION } from "@/store/modules/workstation";
import UserProfileLogo from "../components/UserProfileLogo.vue";
import { BusinessDetailTypeEnum } from "../enums/RolesEnum";

export default /*#__PURE__*/_defineComponent({
  __name: 'EstimateCard',
  props: {
  estimateDetails: {
    type: Object,
  },
},
  emits: ["on-view-estimate-details"],
  setup(__props, { emit: __emit }) {

const emits = __emit;
const props = __props;
const viewEstimateDetails = () => {
  emits("on-view-estimate-details");
};
const store = useStore();
const invitedContractors = ref([]) as any;
const contractorsImages = ref({}) as any;
const workstationImage = ref(null) as any;

const duration = computed(() => {
  if (
    !props.estimateDetails?.suggestedStartDate ||
    !props.estimateDetails?.estimateEndDate
  ) {
    return 0;
  }

  const startDate = moment(props.estimateDetails?.suggestedStartDate) as any;
  const endDate = moment(props.estimateDetails?.estimateEndDate) as any;

  const totalDays = endDate.diff(startDate, "days");

  if (totalDays % 7 === 0) {
    const totalWeeks = totalDays / 7;
    return `${totalWeeks} week${totalWeeks > 1 ? "s" : ""}`;
  }

  return `${totalDays} day${totalDays > 1 ? "s" : ""}`;
});
const formattedDate = computed(() => {
  if (!props.estimateDetails?.suggestedStartDate) {
    return "N/A";
  }
  const date = new Date(props.estimateDetails?.suggestedStartDate);

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString().slice(-2);

  return `${day}-${month}-${year}`;
});

const displayedSkills = computed(() => {
  return props.estimateDetails?.workStation?.user?.userSkills.slice(0, 2);
});

const displaySubCategory = computed(() =>
  getUserSkillList(displayedSkills.value)
);
const totalPhaseAmount = (
  amount: number,
  vat: number,
  isFirstPhase: boolean
) => {
  const SERVICE_CHARGE = 0.03;
  const PHASE_FIRST_CHARGE = 5;
  let sum = 0;

  sum += amount + amount * vat;
  sum += sum * SERVICE_CHARGE;
  if (isFirstPhase) {
    sum += PHASE_FIRST_CHARGE;
  }

  return sum;
};

const estimateBadge = computed(() => {
  if (
    props.estimateDetails?.depositType ===
    EstimateTypeForDeposit.Initial_Estimate
  )
    return "Initial Estimate";
  else if (
    props.estimateDetails?.depositType ===
    EstimateTypeForDeposit.Fixed_Cost_Estimation
  )
    return "Fixed Cost Estimation";
  else if (
    props.estimateDetails?.depositType ===
    EstimateTypeForDeposit.Variable_Cost_Estimation
  )
    return "Variable Cost Estimation";
  else return "";
});

const formattedCurrency = (amount, grantAmount) => {
  let totalCost = amount;
  if (grantAmount) {
    totalCost -= grantAmount;
  }
  return CurrencyFilter.formatToCurrency(totalCost);
};

const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);

const getAllSpecialism = computed(
  () => store.getters[`${USER_STORE}/getAllSpecialism`]
);

const getWsImage = async () => {
  const wsImage = await getImageStringToImageURL(
    props.estimateDetails?.workStation?.profileImage
  );
  try {
    workstationImage.value = wsImage;
  } catch (error) {
    return null;
  }
};

const getUserSkillList = (userSkill: any) => {
  return getUserSubSkillList(userSkill, getAllSpecialism.value);
};

const businessType = computed(() => {
  const subscription = props.estimateDetails?.workStation?.subscription
    ? parseJSON(props.estimateDetails.workStation.subscription)
    : null;

  if (!subscription) {
    return "NA";
  }
  const businessType = subscription?.metadata?.businessType;

  if (businessType) {
    return businessType === BusinessDetailTypeEnum.SOLETRADER
      ? "Sole Trader"
      : businessType === BusinessDetailTypeEnum.LIMITED_COMPANY
      ? "Limited Company"
      : "NA";
  }
  return "NA";
});
onBeforeMount(async () => {
  if (!getAllSpecialism.value.length) {
    await store.dispatch(
      `${USER_STORE}/setAllSpecialismsCategory`,
      activeUserWorkstation.value.id
    );
  }
  const contractors = props?.estimateDetails?.inviteContractors;

  if (contractors && contractors.length) {
    const sliced = contractors.slice(0, 4);
    invitedContractors.value = sliced;
    sliced.map(async (el: any) => {
      if (el?.profileImage) {
        const imageApiUrl = getImageApiUrl(el?.profileImage, true);
        const encoded = (await $axios.get(imageApiUrl)) as any;
        contractorsImages.value[el.id] = encoded.publicUrl;
      }
    });
  }
});

onMounted(async () => {
  await getWsImage();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "estimate__card tw-py-[20px] tw-px-[16px] tw-bg-white tw-rounded-lg tw-max-w-full !tw-shadow-[0px_0px_8px_0px_#0C0F4A14]" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (invitedContractors.value && invitedContractors.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invitedContractors.value, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: _normalizeClass(["tw-absolute tw-top-0 tw-rounded-full tw-w-[40px] tw-h-[40px]", `tw-left-[${i * 15}px]`])
                }, [
                  (!contractorsImages.value[item.id])
                    ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                    : _createCommentVNode("", true),
                  (contractorsImages.value[item.id])
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "tw-rounded-full tw-border-solid tw-border-white tw-w-full tw-h-full tw-object-cover",
                        src: contractorsImages.value[item.id]
                      }, null, 8, _hoisted_4))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ]))
          : (!invitedContractors.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (workstationImage.value)
                    ? (_openBlock(), _createBlock(ImageHolder, {
                        key: 0,
                        class: "tw-ml-[-20px] !tw-h-[40px] !tw-w-[40px]",
                        src: workstationImage.value,
                        isRounded: false
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock(UserProfileLogo, {
                        key: 1,
                        class: "tw-ml-[-20px] !tw-h-[40px] !tw-w-[40px]",
                        userName: __props.estimateDetails?.workStation?.name,
                        isRounded: false
                      }, null, 8, ["userName"]))
                ])
              ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(EstimateBadge, {
            badge: estimateBadge.value,
            bgColor: "#6B5F4B"
          }, null, 8, ["badge"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(__props.estimateDetails?.workStation?.name), 1),
        (__props.estimateDetails?.inviteContractors?.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, " + " + _toDisplayString(__props.estimateDetails?.inviteContractors?.length) + " more ", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", null, _toDisplayString(businessType.value) + " | ", 1),
          (__props.estimateDetails?.workStation?.user?.postcode)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                _createVNode(_component_v_icon, {
                  icon: "mdi-map-marker",
                  size: "10px"
                }),
                _createTextVNode(" " + _toDisplayString(__props.estimateDetails?.workStation?.user?.postcode), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_v_icon, {
            icon: "mdi-star",
            color: "yellow",
            size: "16px"
          }),
          _createElementVNode("span", _hoisted_15, _toDisplayString(__props.estimateDetails?.ratings) + "/5 (" + _toDisplayString(__props.estimateDetails?.jobcompleted) + " Jobs)", 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        (__props.estimateDetails?.workStation?.experience)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(_component_v_icon, {
                class: "tw-text-[12px]",
                icon: "mdi-check-circle",
                color: "green",
                size: "16px"
              }),
              _createElementVNode("span", _hoisted_18, _toDisplayString(__props.estimateDetails?.workStation?.experience || "NA"), 1),
              _hoisted_19
            ]))
          : _createCommentVNode("", true),
        (displayedSkills.value && displayedSkills.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displaySubCategory.value.slice(0, 2), (skill) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: skill.id,
                  class: "tw-flex tw-gap-1 tw-items-center tw-bg-[#f6f6f6] tw-rounded-lg px-2 py-1"
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    (skill?.iconName)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          class: "specialisms_multiselect_modal_item_title_icon"
                        }, {
                          default: _withCtx(() => [
                            (skill?.iconName)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  style: {"width":"10px"},
                                  src: 
                  require('@/assets/category-icons/' + skill?.iconName + '.svg')
                ,
                                  alt: "icon"
                                }, null, 8, _hoisted_22))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_23, _toDisplayString(skill.label), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (displaySubCategory.value.length > 2)
          ? (_openBlock(), _createElementBlock("span", _hoisted_24, " +" + _toDisplayString(displaySubCategory.value.length - 2), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_25, [
        _hoisted_26,
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("span", _hoisted_30, _toDisplayString(formattedDate.value), 1)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("span", _hoisted_33, _toDisplayString(duration.value), 1)
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("span", _hoisted_36, _toDisplayString(formattedCurrency(
                __props.estimateDetails?.totalEstimateCost,
                __props.estimateDetails?.grantAmount
              )), 1)
          ])
        ]),
        _hoisted_37
      ]),
      _hoisted_38,
      _createVNode(Button, {
        variant: "primary",
        label: "VIEW ESTIMATE",
        activeFontColor: "#FFF",
        onClick: viewEstimateDetails
      })
    ]),
    _: 1
  }))
}
}

})